import React, { Fragment, useState } from 'react';
import { Container, Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import axios from 'axios';
import API_BASE_URL from '../../../../Config/api';
import { toast } from 'react-toastify';

const ProductSaleReport = () => {
  const [downloading, setDownloading] = useState(false);

  const downloadReport = async () => {
    setDownloading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/api/reports/product-sale-report`, {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `product_sale_report_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success('Product Sale Report downloaded');
    } catch (err) {
      console.error('Error downloading product sale report:', err);
      toast.error('Failed to download product sale report');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Fragment>
      <Breadcrumbs parent="Reports" title="Product Sale Report" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader className="pb-0">
                <h5>Product Sale Report</h5>
                <p className="text-muted mb-0">
                  Download an Excel workbook of every SKU and the total quantity ordered,
                  sorted by quantity. Each collection (Core Collection and SS&apos;26) is on its own sheet.
                </p>
              </CardHeader>
              <CardBody>
                <Button color="primary" onClick={downloadReport} disabled={downloading}>
                  {downloading ? 'Generating...' : 'Download Excel Report'}
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ProductSaleReport;
